function combineSx(...sxProps) {
    return sxProps.flatMap((sx)=>{
        if (void 0 === sx) return [];
        if (Array.isArray(sx)) return sx;
        return [
            sx
        ];
    });
}
export { combineSx };

//# sourceMappingURL=sx-utils.js.map